var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUsers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.5V8.5C8.5 7.96957 8.28929 7.46086 7.91421 7.08579C7.53914 6.71071 7.03043 6.5 6.5 6.5H2.5C1.96957 6.5 1.46086 6.71071 1.08579 7.08579C0.710714 7.46086 0.5 7.96957 0.5 8.5V9.5M11.5 9.5V8.5C11.4997 8.05686 11.3522 7.62639 11.0807 7.27616C10.8092 6.92593 10.4291 6.67578 10 6.565M8 0.565C8.43021 0.67515 8.81152 0.92535 9.08382 1.27616C9.35612 1.62696 9.50392 2.05841 9.50392 2.5025C9.50392 2.94659 9.35612 3.37804 9.08382 3.72884C8.81152 4.07965 8.43021 4.32985 8 4.44M6.5 2.5C6.5 3.60457 5.60457 4.5 4.5 4.5C3.39543 4.5 2.5 3.60457 2.5 2.5C2.5 1.39543 3.39543 0.5 4.5 0.5C5.60457 0.5 6.5 1.39543 6.5 2.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/users.02482b42.svg";
export { ForwardRef as ReactComponent };